// extracted by mini-css-extract-plugin
export default {"page":"FI","wrapper":"GI","text":"HI","icons":"II","icon":"JI","icon_text":"KI","carousel_wrapper":"LI","slide":"MI","image":"NI","arrows":"OI","prev":"PI","modal_root":"QI","x_mark":"RI","modal":"SI","images":"TI","main_image":"UI","name":"VI"};
    if(module.hot) {
      // 1715091679817
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  